import React from "react"
import { Grid, Link } from "@mui/material"
import { styled } from "@mui/material/styles"
import { FormattedMessage, useIntl } from "react-intl"

import FooterText from "atoms/text/FooterText"
import TextCopyright from "atoms/text/TextCopyright"
import { getLocaleJaOrEnInitialUpper } from "locale.js"

const Container = styled(Grid)({
  backgroundColor: "#727272",
  paddingTop: "20px",
  paddingBottom: "20px",
})

const Spacing = styled(Grid)({
  paddingTop: "9px",
  paddingBottom: "9px",
  paddingRight: "14px",
  paddingLeft: "14px",
})

const Copyright = styled(Grid)({
  paddingTop: "22px",
})

const LinkCentering = () => {
  // const classes = useStyles() // 削除
  const intl = useIntl()
  const privacyPolicyLink = intl.formatMessage({
    id: "Footer.PrivacyPolicyLink",
  })
  const dataGaFAQ = "footerToFAQ" + getLocaleJaOrEnInitialUpper()
  const dataGaPersonalDataCharter =
    "footerToPersonalDataCharter" + getLocaleJaOrEnInitialUpper()
  const dataGaPrivacyPolicy =
    "footerToPrivacyPolicy" + getLocaleJaOrEnInitialUpper()
  const dataGaProvisionToThirdParty =
    "footerToProvisionToThirdParty" + getLocaleJaOrEnInitialUpper()

  return (
    <Container
      container
      direction="column"
      justifyContent="center"
      alignItems="center"
    >
      <Grid item>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
        >
          <Spacing item id="personalDataCharter">
            <Link
              href="https://www.docomo.ne.jp/utility/personal_data/other_info/"
              target="_blank"
              rel="noopener noreferrer"
              data-ga={dataGaPersonalDataCharter}
              underline="hover"
            >
              <FooterText>
                <FormattedMessage id="Footer.PersonalDataCharter" />
              </FooterText>
            </Link>
          </Spacing>

          <Spacing item id="PrivacyPolicy">
            <Link
              href={privacyPolicyLink}
              target="_blank"
              rel="noopener noreferrer"
              data-ga={dataGaPrivacyPolicy}
              underline="hover"
            >
              <FooterText>
                <FormattedMessage id="Footer.PrivacyPolicy" />
              </FooterText>
            </Link>
          </Spacing>

          <Spacing item id="ProvisionToThirdParty">
            <Link
              href="https://id-biz.smt.docomo.ne.jp/src/utility/providing_destinations.html"
              target="_blank"
              rel="noopener noreferrer"
              data-ga={dataGaProvisionToThirdParty}
              underline="hover"
            >
              <FooterText>
                <FormattedMessage id="Footer.ProvisionToThirdParty" />
              </FooterText>
            </Link>
          </Spacing>

          <Spacing item id="FAQ">
            <Link
              href="https://www.docomo.ne.jp/faq/"
              target="_blank"
              rel="noopener noreferrer"
              data-ga={dataGaFAQ}
              underline="hover"
            >
              <FooterText>
                <FormattedMessage id="Footer.FAQ" />
              </FooterText>
            </Link>
          </Spacing>
        </Grid>
      </Grid>

      <Grid item>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
        >
          <Copyright item>
            <TextCopyright />
          </Copyright>
        </Grid>
      </Grid>
    </Container>
  )
}

export default LinkCentering
